module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_orange_05-ed1caac4821b80d00f6750341e5830cf.svg";